export function isDefined(value: any): boolean {
  return value !== undefined;
}
